import React from 'react';

import { ChatWindow } from '~/components';
import { useQuery } from '~/utils/query';

const Chat = () => {
  const { s } = useQuery();

  return (
    <ChatWindow currentSubscription={s} />
  );
};

export default Chat;
